import { useGetClaim } from '@/api'
import { MobileIconButton, MobileIconLink } from '@/components/Core'
import { ClaimNoteFormDrawer } from '@/components/Domains/Claims'
import { ROUTER_PATHS } from '@/lib/constants'
import { AddCustomerCommunicationDrawer } from '@eigtech/ui-shared-claims'
import {
  Box,
  CardAccordion,
  GridItem,
  Heading,
  SimpleGrid,
  Stack,
  chakra,
  useBreakpointValue,
} from '@eigtech/ui-shared-dave'
import { Navigate, createFileRoute, useChildMatches } from '@tanstack/react-router'
import { useState } from 'react'
import { FaMapMarkedAlt } from 'react-icons/fa'
import { MdNoteAdd, MdOutlinePhoneCallback } from 'react-icons/md'
import { TbTimeline } from 'react-icons/tb'
import { routes } from './_layout'

export const Route = createFileRoute('/_auth/claims/$claimNumber/_layout/')({
  component: ClaimBase,
})

function ClaimBase() {
  const { claimNumber } = Route.useParams()

  const isMobile = useBreakpointValue({
    base: true,
    lg: false,
  })

  const matches = useChildMatches()

  if (isMobile && !matches.length) {
    return (
      <Box display={{ base: 'block', lg: 'none' }}>
        <ClaimDetailLinks />
      </Box>
    )
  }

  return <Navigate params={{ claimNumber }} to={ROUTER_PATHS.claimDetailInfo.route} />
}

function ClaimDetailLinks() {
  const { claimNumber } = Route.useParams()

  const { data: claim } = useGetClaim(claimNumber)

  const [isNoteFormDrawerOpen, setIsNoteFormDrawerOpen] = useState(false)
  const [isAddCommunicationDrawerOpen, setIsAddCommunicationDrawerOpen] = useState(false)

  return (
    <>
      <Stack spacing="4">
        <CardAccordion
          defaultToClosed
          heading={
            <Heading as="h3" size="sm">
              Loss Description
            </Heading>
          }
        >
          {claim?.lossDetails.lossDescription || 'No loss description provided.'}
        </CardAccordion>

        <SimpleGrid columns={[3, 3, 4, 5, 6, 7]} spacing={['2', '2', '4']}>
          <GridItem>
            <MobileIconButton Icon={MdNoteAdd} onClick={() => setIsNoteFormDrawerOpen(true)}>
              Add A Note
            </MobileIconButton>
          </GridItem>
          <GridItem>
            <MobileIconButton
              Icon={MdOutlinePhoneCallback}
              onClick={() => setIsAddCommunicationDrawerOpen(true)}
            >
              <chakra.span fontSize="sm" fontWeight="semibold" lineHeight={1.2}>
                Record Communication
              </chakra.span>
            </MobileIconButton>
          </GridItem>
          <GridItem>
            <MobileIconLink
              Icon={FaMapMarkedAlt}
              params={{ claimNumber }}
              to={ROUTER_PATHS.claimDetailMap.route}
            >
              View In Map
            </MobileIconLink>
          </GridItem>
          <GridItem>
            <MobileIconLink
              Icon={TbTimeline}
              params={{ claimNumber }}
              to={ROUTER_PATHS.claimDetailTimeline.route}
            >
              View Timeline
            </MobileIconLink>
          </GridItem>

          {routes.map((route) => (
            <GridItem key={route.id}>
              <MobileIconLink Icon={route.icon} params={{ claimNumber }} {...route.url}>
                {route.label}
              </MobileIconLink>
            </GridItem>
          ))}
        </SimpleGrid>
      </Stack>

      {isNoteFormDrawerOpen && (
        <ClaimNoteFormDrawer
          claimNumber={claimNumber}
          open={isNoteFormDrawerOpen}
          onOpenChange={setIsNoteFormDrawerOpen}
        />
      )}

      {isAddCommunicationDrawerOpen && (
        <AddCustomerCommunicationDrawer
          appDataSource="Delegate"
          claimNumber={claimNumber}
          open={isAddCommunicationDrawerOpen}
          role="inspector"
          onOpenChange={setIsAddCommunicationDrawerOpen}
        />
      )}
    </>
  )
}
